export default {
  title: "Egram Panchayat",
  data: [
    {
      layout: "ContactUsPage",
      title: "સંપર્ક",

      inputs: {
        name: {
          label: "તમારું નામ ",
          placeholder: "તમારું નામ ",
        },
        email: {
          label: "ઇમેઇલ ",
          placeholder: "ઇમેઇલ ",
        },
        mobile: {
          label: "મોબાઈલ નંબર ",
          placeholder: "મોબાઈલ નંબર ",
        },
        complain: {
          label: "ફરિયાદ ",
          placeholder: "ફરિયાદ ",
        },
      },
      btnTitle: "સબમિટ ",
      emailTitle: "ઇ-મેઇલ ",

      successMsg: `
      અમારો સંપર્ક કરવા બદલ આભાર. અમારા સહયોગીઓ ટૂંક સમયમાં તમારો સંપર્ક કરશે.`,
    },
  ],
};
